<app-banner img="https://media.elsasrl.com/storage/elsa-platform/media/static/banners/elsa_banner_prodotti.jpg"
            [title]="PATH_NAME | translate" backgroundColorBorder="gray"></app-banner>
<div class="bg-gray header-container">
  <div class="container">
    <div class="row">
      <div class="col-60 col-lg-30">
        <h3 class="text-uppercase elsa-title-font product-subtitle">{{itemInEvidence?.series.name}}</h3>
        <h2 class="text-uppercase elsa-title-font product-title">{{itemInEvidence?.name}}</h2>
        <h4 class="product-phi-info font-weight-bold mb-0">{{itemInEvidence?.phy_info}}</h4>
        <h5 class="product-description">
          {{itemInEvidence?.applications | implode:'name'}}
        </h5>
      </div>
      <div class="col-60 col-lg-30">
        <div class="position-relative">
          <div class="d-flex flex-row justify-content-center position-absolute w-100 product-image-header-container">
            <img *ngIf="itemInEvidence" [src]="itemInEvidence.image_header.path" class="product-image-header"
                 [alt]="itemInEvidence?.name">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container">
  <div class="row">
    <div class="col-60 col-lg-30">
      <p class="product-description-header mt-5 font-weight-regular">
        {{itemInEvidence?.description_short}}
      </p>
      <div class="d-flex flex-row justify-content-center justify-content-lg-start w-100 mb-5">
        <a title="Elsa" appEmptyTitle *ngIf="itemInEvidence"
           [routerLink]="Paths.Product | page:[itemInEvidence?.name_slug] | localize"
           class="btn btn-gray text-white btn-elsa text-uppercase">{{'label_details' | translate}}</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-60 d-md-none my-4">
      <div class="swiper-container" [swiper]="config">
        <div class="swiper-wrapper">
          <div class="swiper-slide" *ngFor="let item of items">
            <app-box-product [serie]="item.series.name" [name]="item.name" [internalBoring]="item.internal_boring"
                             [internalWelding]="item.internal_welding"
                             [phiInfo]="item.phy_info"
                             [slug]="item.name_slug"
                             [img]="item.image_header.path"
                             [description]="item.applications|implode: 'name'"></app-box-product>
          </div>
        </div>
        <div class="swiper-pagination swiper-pagination-elsa swiper-pagination-lite swiper-pagination-products"></div>
      </div>
    </div>
    <div class="col-30 col-lg-20 d-none d-md-flex my-4" *ngFor="let item of items">
      <app-box-product [serie]="item.series.name" [name]="item.name" [internalBoring]="item.internal_boring"
                       [internalWelding]="item.internal_welding"
                       [phiInfo]="item.phy_info"
                       [slug]="item.name_slug"
                       [img]="item.image_header.path"
                       [description]="item.applications|implode: 'name'"></app-box-product>
    </div>
  </div>
</div>

<section class="container-comparator">
  <div class="inner-container-comparator">
    <div class="row" *ngIf="staticData">
      <div class="col-60 col-md-25 text-white">
        <h5
          class="elsa-title-font text-uppercase title-comparator">{{staticData[staticPageContent.comparator].title}}</h5>
        <div class="description-comparator"
             [innerHTML]="staticData[staticPageContent.comparator].content | safeHtml"></div>
        <button class="btn btn-elsa btn-gray text-uppercase text-white btn-comparator d-none d-md-block"
                (click)="openComparison()">{{staticData[staticPageContent.comparator].subtitle}}</button>
      </div>
      <div class="col-60 col-md-35 img-container">
        <img class="img-comparator" [src]="staticData[staticPageContent.comparator].image.path" alt="Elsa">
        <button class="btn btn-elsa btn-gray text-white text-uppercase btn-comparator d-md-none"
                (click)="openComparison()">{{staticData[staticPageContent.comparator].subtitle}}</button>
      </div>
    </div>
  </div>
</section>

<app-product-warranty-banner></app-product-warranty-banner>

<app-product-footer *ngIf="staticData" [kit]="kitseries" [firstBannerData]="staticData[staticPageContent.kit]"
                    [secondaryBannerData]="staticData[staticPageContent.accessories]"></app-product-footer>
<div class="padding-go-up-button"></div>

<app-link-popup-dialog></app-link-popup-dialog>
